export const STATUS_ARRAY = 'STATUS_ARRAY';